const fullYear = (year) => (year >= 85 && year <= 99 ? `19${year}` : `20${year}`);

const invalidDate = (day, month, year, error) => {
    if (day > 31 || month > 12 || year < 0 || year.length !== 2) throw error;
};

const invalidTime = (hour, minute, second, error) => {
    if (hour > 24 || minute > 60 || second > 60) throw error;
};
/**
 *
 * @param {Object} headerValues
 * Parse start time and start date strings from EDF header and
 * returns an ISO 8601 formatted date string
 */
export const buildRecStartDateTimeISO = (headerValues) => {
    const { start_time, start_date } = headerValues; // eslint-disable-line
    try {
        // EDF+ specs section 2.1.3. Additional specifications in EDF+, item 2.
        // JavaScript Date Object counts months from 0 to 11. January is 0. December is 11.
        const [day, month, year] = start_date.split('.');
        const [hour, minute, second] = start_time.split('.');
        invalidDate(day, month, year, new Error('Date is not valid'));
        invalidTime(hour, minute, second, new Error('Time is not valid'));
        const utcDate = Date.UTC(
            fullYear(year),
            parseInt(month, 10) - 1,
            day,
            hour,
            minute,
            second
        );

        return new Date(utcDate).toISOString();
    } catch (error) {
        // eslint-disable-next-line
        console.warn(`EDF does not contain either a valid start_date or start_time.
    Resorting to default date and time. 
    start_date: ${start_date}, start_time: ${start_time}`); // eslint-disable-line

        // FIXME: Setting to fallback date breaks adding annotation functionality.
        return '1970-01-01T00:00:00.000Z';
    }
};
